<div class="di-btn-container" [ngClass]="{'di-btn-border': hasBorder, 'disabled': disabled}" role="button" aria-pressed="false"
  aria-label="Button with icon" [id]="id" dianaPreventDoubleClick  [isPreventDoubleClickActive]="activatePreventDoubleClick" (click)="doAction()">
  @if (iconName) {
    <mat-icon>{{iconName}}</mat-icon>
  }
  @if (textLabel) {
    <span [ngClass]="{'di-btn-margin': iconName}" class="di-button-label">
      {{textLabel}}
    </span>
  }
</div>